import { useFormContext } from 'react-hook-form';
import { FormCheckbox } from 'redesign';
import { getRequiredMessage } from './shared';
import { IsEmployeeFormContext, Props } from './is-employee.types';

export const IsEmployeeCheckbox = (props: Props) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<IsEmployeeFormContext>();
  const formName = 'isEmployee';
  const label = 'Employee';
  const requiredMessage = getRequiredMessage(label);
  return (
    <FormCheckbox
      name={formName}
      control={control}
      label={label}
      disabled={props.disabled}
      rules={{
        ...(props.required ? { required: requiredMessage } : {}),
        ...(props.validate ? { validate: props.validate } : {}),
      }}
      onChange={props.onChange}
      checkboxError={errors.isEmployee?.message}
    />
  );
};
